<template>
  <div>
    <div class="header">
      <img class="logo" src="@/assets/campina-grande.png" />
      <div class="clock">{{clock}}</div>
      <div class="stop-name">{{panelConfig.panelHeader}}</div>
    </div>
    <DeparturesTableAlt :panelConfig="panelConfig" :stopData="stopData" :hideNextDay="true"></DeparturesTableAlt>
  </div>
</template>

<script>
import DeparturesTableAlt from './DeparturesTableAlt';

export default {
  components: {
    DeparturesTableAlt
  },

  props: ['panelConfig', 'stopData', 'clock'],

  created() {
    this.markNextDayTrips(this.stopData.trips);
  },

  watch: {
    stopData: function(newVal, oldVal) {
      this.markNextDayTrips(newVal.trips);
    }
  },

  methods: {
    markNextDayTrips(trips) {
      trips.forEach((trip) => {
        trip.nextDayOnly = trip.times.filter((dep) => dep.nextDay === false).length === 0;
      });
    }
  },
};
</script>

<style lang="scss">
.header {
  padding: 1em .6em;
  background-color: #144896;
  color: #fff;
}
.logo {
  height: 2.5em;
  margin-top: -.65em;
}
.clock {
  float: right;
}
.stop-name {
  text-align: center;
  margin-top: .5em;
}

table {
  th {
    background: #407cbb !important;
  }
}

@media only screen and (min-width: 600px) {
  .header {
    height: 3.25em;
  }
  .clock {
    font-size: 2em;
    margin-top: -.35em;
  }
  .stop-name {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3.25em;
    padding: 0 10em;
    margin-top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>